import OrgChartNodeView from './OrgChartNodeView';

export default OrgChartNodeView;
